import { render, staticRenderFns } from "./OrderDetailCard.vue?vue&type=template&id=448e6816&"
import script from "./OrderDetailCard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailCard.vue?vue&type=style&index=0&id=448e6816&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports